import { PropsWithChildren } from 'react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Heading, Tray } from '@frontend/design-system';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = PropsWithChildren<{
  onBackClick?: () => void;
  title: string;
}>;

export const AudienceTrayHeader = ({ children, onBackClick, title }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { closeTray, trackingIdPrefix } = useAudienceTray();

  return (
    <Tray.Header
      Buttons={
        <Button
          css={{ svg: { color: theme.colors.neutral90 } }}
          hoverLabel={t('Close')}
          iconName='x'
          onClick={closeTray}
          trackingId={`${trackingIdPrefix}-tray-header-close-btn`}
          variant='tertiary'
          size='large'
        />
      }
    >
      <div>
        <div css={{ display: 'flex', columnGap: theme.spacing(1), alignItems: 'center' }}>
          {onBackClick && (
            <Button
              variant='tertiary'
              iconName='caret-left'
              onClick={onBackClick}
              hoverLabel={t('Back')}
              trackingId={`${trackingIdPrefix}-tray-header-back-btn`}
              css={{
                svg: {
                  color: theme.colors.neutral90,
                  height: 20,
                  width: 20,
                },
              }}
            />
          )}
          <Heading level={2} css={{ margin: 0 }}>
            {title}
          </Heading>
        </div>
        {children}
      </div>
    </Tray.Header>
  );
};
